import { render, staticRenderFns } from "./AdminControl.vue?vue&type=template&id=713d540a&"
import script from "./AdminControl.vue?vue&type=script&lang=ts&"
export * from "./AdminControl.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports